<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                       Section Installment Summary Report
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
             <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        @change="putnull()"
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        persistent-hint
                        hint="Please select academic year"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        @change="putnull()"
                        v-model="section"
                        item-value="id"
                        multiple
                        :items="section_list"
                        item-text="name"
                        label="Select Section"
                        outlined
                        persistent-hint
                        hint="Please select section"
                    />
                </v-col>
                <v-col cols="12" md="3" sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list" item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                  <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && section">
                    <v-btn class="mt-6 button" @click="onload()">Fetch / Generate</v-btn>
                </v-col>
             </v-row>
        </v-card>
        <span v-if="show == true">
            <section-summary-report :section="section"></section-summary-report>
        </span>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
     import SectionFeeSummaryReport from "./SectionFeeSummaryReport";
    export default {
        components:{
            "section-summary-report":SectionFeeSummaryReport
        },
        data() {
            return {
                snackbar_msg: "",
                color: "",
                snackbar: false,
                overlay: false,
                search: null,
                installment_details: [],
                dialog:false,
                std_id:null,
                ay_std_div_list: null,
                sel_ay_data: null,
                ay_id:null,
                section_list:null,
                section:null,
                section:[],
                show:false,
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: null,
            };
        },
        watch: {            
            overlay(val) {
            val = () => {
                this.overlay = false;
            };
            },
        },
        methods: {
            putnull(){
                this.show = false
            },
            close(){
                this.std_id=null
                this.dialog = false;
            },
            getStatus(item,ay_id){
                this.std_id = item
                this.ay_id = ay_id
                this.dialog = true
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                 localStorage.setItem("setstatus", this.status);
                //localStorage.setItem("setsection", this.section);
                this.show = true
             //   this.overlay = true
            },
            main() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        // this.section_list = res.data.section_list
                        this.section_list = res.data.section_list.filter(item => item.name !== "All");
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.main();
        },
    };
</script>
<style scoped>
    .text-color {
        font-weight: bold;
        color: red;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
